/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * StavertonAPI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  DeleteZoneItemParams,
  GetZoneItemParams,
  ListZoneItemsParams,
  ZoneItemCreateRequest,
  ZoneItemCreateResponse,
  ZoneItemDeleteResponse,
  ZoneItemGetResponse,
  ZoneItemListResponse,
  ZoneItemUpdateRequest,
  ZoneItemUpdateResponse
} from './index.schemas';

import { useCustomInstance } from '../staverton.openapi.axios';





export const useListZoneItemsHook = () => {
        const listZoneItems = useCustomInstance<ZoneItemListResponse>();

        return useCallback((
    params?: ListZoneItemsParams,
 signal?: AbortSignal
) => {
        return listZoneItems(
          {url: `/ZoneItem/List`, method: 'GET',
        params, signal
    },
          );
        }, [listZoneItems])
      }
    

export const getListZoneItemsQueryKey = (params?: ListZoneItemsParams,) => {
    return [`/ZoneItem/List`, ...(params ? [params]: [])] as const;
    }

    
export const useListZoneItemsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>, TError = unknown>(params?: ListZoneItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListZoneItemsQueryKey(params);

  const listZoneItems =  useListZoneItemsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>> = ({ signal }) => listZoneItems(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListZoneItemsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>>
export type ListZoneItemsQueryError = unknown


export function useListZoneItems<TData = Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>, TError = unknown>(
 params: undefined |  ListZoneItemsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListZoneItems<TData = Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>, TError = unknown>(
 params?: ListZoneItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListZoneItems<TData = Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>, TError = unknown>(
 params?: ListZoneItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListZoneItems<TData = Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>, TError = unknown>(
 params?: ListZoneItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListZoneItemsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListZoneItemsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useGetZoneItemHook = () => {
        const getZoneItem = useCustomInstance<ZoneItemGetResponse>();

        return useCallback((
    params?: GetZoneItemParams,
 signal?: AbortSignal
) => {
        return getZoneItem(
          {url: `/ZoneItem/Get`, method: 'GET',
        params, signal
    },
          );
        }, [getZoneItem])
      }
    

export const getGetZoneItemQueryKey = (params?: GetZoneItemParams,) => {
    return [`/ZoneItem/Get`, ...(params ? [params]: [])] as const;
    }

    
export const useGetZoneItemQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>, TError = unknown>(params?: GetZoneItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetZoneItemQueryKey(params);

  const getZoneItem =  useGetZoneItemHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>> = ({ signal }) => getZoneItem(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetZoneItemQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>>
export type GetZoneItemQueryError = unknown


export function useGetZoneItem<TData = Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>, TError = unknown>(
 params: undefined |  GetZoneItemParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetZoneItem<TData = Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>, TError = unknown>(
 params?: GetZoneItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetZoneItem<TData = Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>, TError = unknown>(
 params?: GetZoneItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetZoneItem<TData = Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>, TError = unknown>(
 params?: GetZoneItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetZoneItemHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetZoneItemQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useCreateZoneItemHook = () => {
        const createZoneItem = useCustomInstance<ZoneItemCreateResponse>();

        return useCallback((
    zoneItemCreateRequest: ZoneItemCreateRequest,
 signal?: AbortSignal
) => {
        return createZoneItem(
          {url: `/ZoneItem/Create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: zoneItemCreateRequest, signal
    },
          );
        }, [createZoneItem])
      }
    


export const useCreateZoneItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateZoneItemHook>>>, TError,{data: ZoneItemCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateZoneItemHook>>>, TError,{data: ZoneItemCreateRequest}, TContext> => {

const mutationKey = ['createZoneItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createZoneItem =  useCreateZoneItemHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateZoneItemHook>>>, {data: ZoneItemCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createZoneItem(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateZoneItemMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateZoneItemHook>>>>
    export type CreateZoneItemMutationBody = ZoneItemCreateRequest
    export type CreateZoneItemMutationError = unknown

    export const useCreateZoneItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateZoneItemHook>>>, TError,{data: ZoneItemCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateZoneItemHook>>>,
        TError,
        {data: ZoneItemCreateRequest},
        TContext
      > => {

      const mutationOptions = useCreateZoneItemMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useUpdateZoneItemHook = () => {
        const updateZoneItem = useCustomInstance<ZoneItemUpdateResponse>();

        return useCallback((
    zoneItemUpdateRequest: ZoneItemUpdateRequest,
 ) => {
        return updateZoneItem(
          {url: `/ZoneItem/Update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: zoneItemUpdateRequest
    },
          );
        }, [updateZoneItem])
      }
    


export const useUpdateZoneItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateZoneItemHook>>>, TError,{data: ZoneItemUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateZoneItemHook>>>, TError,{data: ZoneItemUpdateRequest}, TContext> => {

const mutationKey = ['updateZoneItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateZoneItem =  useUpdateZoneItemHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateZoneItemHook>>>, {data: ZoneItemUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateZoneItem(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateZoneItemMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateZoneItemHook>>>>
    export type UpdateZoneItemMutationBody = ZoneItemUpdateRequest
    export type UpdateZoneItemMutationError = unknown

    export const useUpdateZoneItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateZoneItemHook>>>, TError,{data: ZoneItemUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateZoneItemHook>>>,
        TError,
        {data: ZoneItemUpdateRequest},
        TContext
      > => {

      const mutationOptions = useUpdateZoneItemMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useDeleteZoneItemHook = () => {
        const deleteZoneItem = useCustomInstance<ZoneItemDeleteResponse>();

        return useCallback((
    params?: DeleteZoneItemParams,
 ) => {
        return deleteZoneItem(
          {url: `/ZoneItem/Delete`, method: 'DELETE',
        params
    },
          );
        }, [deleteZoneItem])
      }
    


export const useDeleteZoneItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteZoneItemHook>>>, TError,{params?: DeleteZoneItemParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteZoneItemHook>>>, TError,{params?: DeleteZoneItemParams}, TContext> => {

const mutationKey = ['deleteZoneItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteZoneItem =  useDeleteZoneItemHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteZoneItemHook>>>, {params?: DeleteZoneItemParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteZoneItem(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteZoneItemMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteZoneItemHook>>>>
    
    export type DeleteZoneItemMutationError = unknown

    export const useDeleteZoneItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteZoneItemHook>>>, TError,{params?: DeleteZoneItemParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteZoneItemHook>>>,
        TError,
        {params?: DeleteZoneItemParams},
        TContext
      > => {

      const mutationOptions = useDeleteZoneItemMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    